import { useState } from "react";
import { BankAccountService } from "../../../../services/BankAccountService";
import { FaSpinner, FaTrashCan, FaXmark } from "react-icons/fa6";

export const BankAccountDeleteConfirm = ({
    open,
    setOpen,
    data,
    refreshData,
}) => {
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await BankAccountService.delete({ id: data?.id});

            setOpen(false);
            if (refreshData) refreshData();
        } catch (err) {
            // handleError(err, "Gagal menerbitkan invoice dengan pembayaran.");
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            onClick={() => setOpen(false)}
        >
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
            <div
                className="relative w-full max-w-sm rounded-2xl overflow-hidden shadow-2xl"
                style={{
                    background: "rgba(15, 23, 42, 0.95)",
                    border: "1px solid rgba(51, 65, 85, 0.4)",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="px-5 py-4 flex items-center justify-between"
                    style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.3)" }}
                >
                    <h3 className="text-sm font-bold text-gray-100">Hapus Rekening</h3>
                    <button
                        onClick={() => setOpen(false)}
                        className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-gray-100 hover:bg-slate-700/50 transition-all"
                    >
                        <FaXmark className="text-sm" />
                    </button>
                </div>
                <div className="p-5 text-center">
                    <div
                        className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4"
                        style={{
                            background: "rgba(239, 68, 68, 0.12)",
                            border: "1px solid rgba(239, 68, 68, 0.2)",
                        }}
                    >
                        <FaTrashCan className="text-2xl text-red-400" />
                    </div>
                    <p className="text-gray-200 font-medium mb-1">
                        Hapus rekening {data?.bank_name}?
                    </p>
                    <p className="text-xs text-slate-500 font-mono">
                        {data?.account_number}
                    </p>
                    <p className="text-xs text-slate-500 font-mono">
                        {data?.account_holder_name}
                    </p>
                    <p className="text-xs text-slate-500 mt-3">
                        Tindakan ini tidak dapat dibatalkan
                    </p>
                </div>
                <div
                    className="px-5 py-4 flex gap-3"
                    style={{ borderTop: "1px solid rgba(51, 65, 85, 0.3)" }}
                >
                    <button
                        onClick={() => setOpen(false)}
                        disabled={loading}
                        className="flex-1 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-300 transition-all disabled:opacity-50"
                        style={{
                            background: "rgba(51, 65, 85, 0.3)",
                            border: "1px solid rgba(51, 65, 85, 0.3)",
                        }}
                    >
                        Batal
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={loading}
                        className="flex-1 px-4 py-2.5 rounded-xl text-sm font-medium text-white bg-red-600 hover:bg-red-500 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                        {loading ? (
                            <>
                                <FaSpinner className="animate-spin text-xs" /> Menghapus...
                            </>
                        ) : (
                            <>
                                <FaTrashCan className="text-xs" /> Hapus
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};